const THEME_VARS = {
  verse: "--color-node-verse",
  talk: "--color-node-talk",
  cfm: "--color-node-cfm",
  apparatus: "--color-node-apparatus",
  foundational: "--color-node-foundational",
  external: "--color-node-external",
  default: "--color-node-default",
  center: "--color-node-center",
  edgeHigh: "--color-edge-high",
  edgeMid: "--color-edge-mid",
  edgeLow: "--color-edge-low",
  personalEdge: "--color-edge-personal",
  surfaceMuted: "--surface-muted",
}

const APPARATUS_TYPES = new Set([
  "topical_guide_entry",
  "bible_dictionary_entry",
  "triple_index_entry",
])

const FOUNDATIONAL_TYPES = new Set(["foundational_text", "foundational_text_section"])

function readCssVar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}

export function readGraphTheme() {
  return Object.fromEntries(
    Object.entries(THEME_VARS).map(([key, varName]) => [key, readCssVar(varName)])
  )
}

export function nodeColorForType(nodeType, theme) {
  if (nodeType === "scripture_verse") return theme.verse
  if (nodeType === "conference_talk") return theme.talk
  if (nodeType === "cfm_lesson") return theme.cfm
  if (APPARATUS_TYPES.has(nodeType)) return theme.apparatus
  if (FOUNDATIONAL_TYPES.has(nodeType)) return theme.foundational
  if (nodeType === "speaker") return theme.talk
  if (nodeType === "hymn_text") return theme.foundational
  return theme.default
}

export function edgeStyleForConfidence(confidence, theme) {
  if (confidence >= 1.0) {
    return { color: theme.edgeHigh, opacity: 1, width: 2, dash: null }
  }
  if (confidence >= 0.85) {
    return { color: theme.edgeMid, opacity: 0.75, width: 1.75, dash: null }
  }
  return { color: theme.edgeLow, opacity: 0.5, width: 1.5, dash: [6, 4] }
}

export function edgeStyleForLink(link, theme) {
  if (link.link_kind === "personal") {
    return { color: theme.personalEdge, opacity: 0.95, width: 2.5, dash: [4, 4] }
  }

  const base = edgeStyleForConfidence(link.confidence, theme)

  switch (link.edge_type) {
    case "quotes":
      return { ...base, width: 3, dash: null }
    case "cites_scripture":
      return { ...base, width: 2, dash: null }
    case "alludes_to":
      return { ...base, dash: [8, 4] }
    case "echoes":
      return { ...base, width: 1.5, dash: [2, 4] }
    default:
      return base
  }
}

export function applyOpacity(color, opacity) {
  if (!color) return color
  if (color.startsWith("#") && color.length === 7) {
    const alpha = Math.round(opacity * 255)
      .toString(16)
      .padStart(2, "0")
    return `${color}${alpha}`
  }
  return color
}
